import type React from "react";
import { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Tooltip,
  Chip,
} from "@mui/material";
import {
  Download as DownloadIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import apiService from "../../../service/Api";

interface StreamData {
  id: number;
  booking: {
    id: number;
    deceased: Array<{
      first_name: string;
      second_name?: string;
      surname: string;
    }>;
    services?: Array<{
      venue?: {
        name: string;
      };
    }>;
  };
  date: string;
  address_one?: string;
  city?: string;
}

interface ServiceDeliveryNoteCardProps {
  stream?: StreamData;
}

const ServiceDeliveryNoteCard: React.FC<ServiceDeliveryNoteCardProps> = ({
  stream,
}) => {
  const navigate = useNavigate();
  const [isSigned, setIsSigned] = useState(false);

  useEffect(() => {
    if (!stream?.id) return;
    let isMounted = true;
    apiService
      .get<
        { status: string }[] | { results: { status: string }[] }
      >(`/api/streams/service-delivery-note/?stream=${stream.id}`)
      .then((response) => {
        const data = response.data;
        const note = Array.isArray(data) ? data[0] : data.results?.[0];
        if (isMounted) setIsSigned(note?.status === "signed");
      })
      .catch(() => {});
    return () => {
      isMounted = false;
    };
  }, [stream?.id]);

  const handleNavigate = () => {
    navigate(`/stream-management/view/${stream?.id}/service-delivery-note`);
  };

  return (
    <Card sx={{ boxShadow: 0, mt: 2 }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 0 }}>
              Service Delivery Note
            </Typography>
            {isSigned && (
              <Chip
                icon={<CheckCircleIcon sx={{ fontSize: 16 }} />}
                label="Signed"
                color="success"
                size="small"
                variant="outlined"
              />
            )}
          </Box>

          <Tooltip title="View Service Delivery Note">
            <IconButton onClick={handleNavigate} color="primary">
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ServiceDeliveryNoteCard;
